export const definitions: { [key: string]: string } = {
  adjbud: 'sand, beach',
  adjuh: "I don't know, said after a joke",
  awurd: "goodness me, 'oh how dear it is'",
  badbu: "that's what I mean!, when (subordinate conjunction)",
  badjan: 'big, main',
  bakki: 'tobacco',
  baladj: 'leech',
  balang: 'skin name (male), male subsection name of <b>duwa</b> patri-moiety',
  balay: 'far',
  bambam: 'black termite mound',
  baleh: 'where, what, how',
  bangku: 'mixed Aboriginal and non-Aboriginal descent',
  barli: 'crooked, twisted, skewed, bent',
  barung: 'smear, paint',
  barra: 'wet season wind, north-west monsoons',
  barrk: 'black wallaroo, wallaroo, black (male only)',
  bawon: 'leave, leave untouched, abandon, part contact, fall off, give up',
  bawurl: 'chicken, fowl',
  baybay: 'inside, within, deep down',
  bebke: 'reveal, bring out, take out, produce children',
  bedda: 'they, them, third person augmented direct free pronoun',
  bedman: 'themselves, by themselves',
  bekka: 'file snake, Arafura file snake, <i>Acrochordus arafurae</i>',
  bekkan: 'listen, hear, feel, touch',
  belinj: 'subsection (female) of <b>duwa</b> patri-moiety',
  benuk: 'bush turkey, Ardeotis australis',
  berlu: 'aunty',
  kunbid: 'hand, finger, paw, claw, trigger, button',
  bidbun: 'climb, climb up, get into, get onto, rise, blister, enter ceremony',
  bidmak: 'skilled, dexterous',
  manbik: 'splinter',
  bikku: 'spotted tree monitor, goanna (spotted tree monitor)',
  bilem: 'canoe (bark), bark canoe',
  bininj: 'man, person, human, Aboriginal person, male',
  birdi: 'beeswax',
  nabirl: 'disabled person, cripple',
  bokung: 'black bittern, <i>Ixobrychus flavicollis</i>',
  birndu: 'mosquito, march fly, glossy ibis',
  biwudj:
    'green pygmy-goose, <i>Nettapus pulchellus</i>, pink-eared duck, <i>Melacorhynchus membranaceus</i>',
  kunbok: 'track, footprint',
  bokenh: 'two',
  bokkan: 'follow tracks, track',
  bokko: 'barbed spear',
  bokorn: 'spangled grunter, Leiopotherapon unicolor',
  bolmo: 'clan name',
  bolkan: 'follow, come after',
  bonbon: 'little black cormorant, <i>Phalacrocorax sulcirostris</i>',
  bongka:
    'long-tailed rock monitor, black-palmed monitor, <i>Varanus glebopalma</i>',
  bornan: 'father child',
  kunboy: 'termite mound',
  boyen: 'recently, before (recently)',
  boywek: 'knob-tailed gecko, <i>Nephurus sheai</i>, <i>Nephurus asper</i>',
  budjum: 'sandworm',
  bukbuk: 'pheasant coucal, <i>Centropus</i> phasianinus',
  bukka: 'that, over there, thing',
  bukkan: 'show, teach, demonstrate',
  burlng: 'grub, moth larvae, tiny ant sp., boil',
  bulanj:
    'skin name (male), subsection (male) of <b>yirridjdja</b> patri-moiety',
  bulbbe: 'dilly bag',
  bulumo: 'clan name',
  bulkay: 'Bulkay, place name on the Tomkinson River flood plain',
  bunidj: 'clan name',
  bunje: 'blind person',
  burdoh: 'clan name',
  burarr: "water goanna, Merten's water goanna, <i>Varanus mertensi</i>",
  buyhmi: 'clan name, Buyhmi clan',
  dabbe: 'paper wasp',
  dabke: 'close in on, trap, meet, meet halfway',
  dabuno: 'egg',
  kundad: 'leg',
  dadbe: 'king brown snake',
  dadjke: 'cut, slice, divide, draw dividing line, cut off, interrupt',
  dahme: 'refuse, turn down, block',
  mandak: '<i>Persoonia falcata</i>, Milky plum',
  daluk: 'woman, wife, female',
  danek: 'clan name',
  darlk: 'clap, crack, click',
  dedded: 'red-collared lorikeet',
  deddel: 'black ant',
  delek: 'white clay, white ochre, kaolin, huntite',
  delkke: 'splash, spill, splatter',
  mandem: 'waterlily, waterlily corms, <i>Nymphaea sp</i>. roots',
  demed: 'place name in Kumadderr river region, Demed',
  dirdko: 'moonlight',
  kundiw: 'liver',
  dolek: 'wood grubs',
  kundoy: 'father-in-law and son-in-law relationship, arranged marriage',
  doydoy: 'great-grandparent, great-grandchild, father-in-law',
  dukkan: 'tie up, wrap, wrap up, coil around, put in handcuffs',
  dumdum: 'beetle',
  duninj: 'real, really, actual, proper',
  duruk: 'dog, <i>Canis familiaris</i>',
  djabbo: 'quoll, Dasyurus hallucatus',
  djabel: 'mouth almighty fish, <i>Glossamia aprion</i>',
  djaddi: 'frog (generic)',
  djadme: 'talk straight, set straight, not use respect register',
  djamun: '1. Sacred, restricted, 2. Police',
  djanay: 'kind of goanna, yellow-spotted monitor',
  djanbe: 'in a group, crowded together, as a flock or school',
  djandi: 'Sunday, week',
  djang: 'totemic site, dreaming, sacred site, totemic emblem, dreaming',
  djawan: 'ask',
  djedje: 'child, son, daughter',
  djenj: 'fish, fishing',
  djerli: "Mitchell's water monitor, <i>Varanus mitchelli</i>",
  djerrh: 'string bag, dilly bag',
  djirla: 'salt',
  djobke: 'cut, draw a line',
  djodj: 'centipede',
  djord: 'axe head',
  djudju: 'toothache',
  djudme: 'prod, jab, poke',
  djuhke: 'splash, shower, immerse, bathe, inundate',
  djukka: 'sugar',
  djunj: 'bubble',
  djulu: 'matches',
  djurra: 'paper, book, document, letter',
  djuwe: 'Great bowerbird, <i>chlamydera nuchalis</i>',
  kunka: 'spine, spike',
  kabbal: 'plain, open area, floodplain',
  kabbay: 'ironwood tree resin',
  kabun: 'He/she/it hits',
  kaddum: 'up high, at the top, up, above, in the sky, loudly',
  kukak: 'at night',
  kunkak: 'night, day',
  kakbi: 'north',
  kakkak: 'grandmother, grandfather',
  kunkal: 'marrow',
  kalawu: 'timber platform for the deceased',
  kaluk: 'after, later, then , and, but',
  kamak: 'Good, it is good, OK',
  kamanj: 'skin name (female), subsection (female) of <b>duwa</b> patri-moiety',
  kamarn: 'Arum plant species, <i>Amorphophallus paeoniifolius</i>',
  kambuk: 'small crab',
  kambe: 'termite mound',
  kanjok: 'brother-in-law, wife, husband, sister-in-law',
  kardab: "spider, spider's web",
  karlba: 'yellow ochre',
  karung: 'It burns (verb: rung)',
  karrme:
    'have, own, possess, keep, hold onto, have offspring, have children, win',
  kawolk: 'Silver-crowned friar bird, <i>Philemon argenticeps</i>',
  kaybun: 'withhold from, refuse, deny',
  kayhme: 'call out, yell',
  kunkeb:
    'nose, face, beak (of bird), bow (of boat), grill (of a car, front of a car), hook (fishing), peg of spearthrower, entrance to honey hive, burning log, valve',
  kebkan: 'take dogs hunting',
  kebmak: 'good looking, handsome, pretty, beautiful, attractive',
  kelbi: 'crocodile lair or tunnel',
  kename: 'take note of a location',
  kunkih: 'mud',
  kilel: 'small, little',
  kimang: 'send word for someone to come, call to oneself',
  kinga: 'saltwater crocodile',
  kinje: 'cook, burn, light up',
  mankod: 'paperbark tree',
  kunkod: 'paperbark, playing cards',
  kodjok:
    'skin name (male), subsection (male) of <b>yirridjdja</b> patri-moiety and <b>ngarradjku</b> matri-moiety',
  koknan: 'observe',
  kokok: 'older brother',
  kunkom: 'neck, throat',
  kondah: 'here',
  koroyi: 'having a long legless body',
  koyek: 'east',
  koyhbe: 'egg yolk',
  kubba: 'crowbar, digging stick',
  kubumi: 'Kubumi, place name on the Mann River',
  kunkuk: 'body, shape, form',
  mankuk: 'Raw, uncooked, unripe',
  kukkan: 'carry animal, carry body',
  kukku: 'water',
  kukun: 'right',
  kunkun: 'right hand, right',
  kunak: 'fire, cigarette lighter, matches',
  kunbak: 'water weed, algae, aquatic herbs',
  kurndi: 'witchetty grub',
  kunekke: 'that one',
  kunukka: 'in that way, about this, in connection with this',
  kunworr: 'leaf, leaves of any plant',
  kured: 'home, house, at home',
  kurih: 'over there',
  kurulk: 'clan name',
  kurrid: 'on the edge, on the side, beside, on the perimeter, along the edge',
  kurrih: 'blue-tongued lizard, northern blue-tongued skink',
  kurrme:
    'put, place, lay, deposit, drop off, lay egg, turn on, pronounce, assert, lay down',
  kuyal: 'ceremonial grouping',
  kuybuk: 'banksia tree, Banksia_dentata',
  kuykme: 'spray',
  laddum: 'sinker, lead shot, circumcised',
  larrk: 'no, nothing',
  larrwa: 'pipe',
  lindji: 'place name in Kumadderr river region',
  manlod:
    'round object, cylindrical/oblong thing, cylindrical/oblong thing, round object, loaf',
  loklok: 'skink',
  kunlon: 'injury, wound',
  kunmad: 'ankle',
  madbun: 'wait',
  madjba: 'clan name',
  makali: 'mud codnorthern mud cod, <i>Ophiocara porocephala</i>, mud cod',
  makka: 'that, it',
  malayu:
    'Macassan, Makassarese person, Macassar, Sulawesi, Malayo-Polynesian language speaking area',
  mamam:
    "grandfather (mother's father), mother's father's sister, grandchild (daughter's children)",
  mamumu: 'Cajaput paperbark, <i>Melaleuca cajuputi</i>',
  manbu: 'which, that',
  marla: 'scorpion',
  morak: 'Morak ceremony',
  marlwa: 'spirit being, song series name',
  marne:
    'for, benefactive verbal prefix, prefix that emphasises that an action relates to a particular person',
  marebu: 'mat',
  marram: 'whistling kite, <i>Milvus sphenurus</i>',
  mawah:
    "grandfather (father's father), great aunt, great uncle (father's father's siblings), grandchild (son's children), grand-niece, grand-nephew (brother's son's children), parallel patrilineal grandkin",
  manme: 'food',
  medjek: 'goose wing fan, feather, fin',
  kunmen: 'knowledge',
  midbun: 'mistake the identity of someone',
  mikan: 'accompany, come along',
  kunmim: 'eye',
  manmim: 'seed, bullet',
  mimih: 'Mimih spirit',
  mirarr: 'clan name',
  kunmok: 'sore, scab, infection',
  moken: 'group, whole lot, everything',
  molkno: 'secretly , stealthily, furtively, in secret',
  morne: "carrying on one's shoulders, piggyback",
  kunmud: 'hair (of body), feathers, fur',
  mudmud: 'sandfly, horse-fly',
  mulbbu: 'small mammals',
  mulil: 'ceremonial feast, public celebration, many, heaps, lots',
  munun: 'dark',
  mungu: 'innocent',
  morlah:
    "aunt (mother's older sister), niece, nephew (woman calls the children of her younger sister)",
  murru: 'black flying-fox',
  nabiwo: 'honey from Tetragonula mellipes bees.',
  nahnan: 'look after, care for',
  nahni: 'he, him, it',
  nakka: 'he, it',
  nakurl: "last storms of wet season, 'knock'em downs'",
  namud: 'family',
  namung: '<i>Demansia atra</i>, black whip snake',
  naworo: 'place name in Kumadderr river region',
  nayin: 'snake',
  kunney: 'elbow',
  norne: 'wasp species',
  kunnud: 'pus, discharge, rotting substance',
  nungan: 'himself',
  nungka: 'he, him',
  ngabba: 'father, dad',
  ngalbu: 'it, she, that',
  ngali: 'she, her',
  ngalke: 'find',
  ngalng:
    'shell, yabby, <i>Cherax bicarinatus</i>., container, pot, pan, term of reference used by a man about his sister',
  ngamed: 'whatsisname, whatshername',
  ngard: 'northern snapping turtle, <i>Elseya dentata</i>',
  ngaye: 'I, me',
  ngehke: 'save',
  nginj: 'hook (fishing), spear tip',
  ngolin: 'beeswax',
  ngudda: 'your',
  njale: 'something, anything',
  njamed: 'whatchamacallit, um',
  njokme: 'bark (of dogs)',
  rlobme: 'run',
  kunrak: 'fire, firewood',
  rakalk: 'sorcerer',
  rakul: 'partridge pigeon',
  rarrk: 'cross-hatching',
  rawon: 'combine, mix, add',
  kunred: 'home, country',
  rongmak: 'good at dodging',
  royhme: 'spy, peek',
  wabban: 'handle',
  wabun: 'sing someone or something',
  manwak: 'Leea rubra',
  wakih:
    'prawn, river prawns, kakadu shrimp, common Kakadu shrimp, <i>Leptopalaemon gagadjui</i>, <i>Macrobrachium spp</i>.',
  walabi: 'traditional fishing net',
  walem: 'south',
  wamba: 'river shark',
  wamud: 'subsection (male) of <b>duwa</b> patri-moiety, skin name (male)',
  wanjh: 'then, after that, then, now, so',
  wardi: 'otherwise, propositional',
  warre: 'poor thing, oh dear, too bad',
  wayhke: 'lift',
  wayuk: 'waterlily, <i>Nymphaea violacea</i>',
  kunwel: 'wing',
  weleng: 'responsible party',
  weleyh: 'red-winged parrot, <i>Aprosmictus erythropterus</i>',
  wernh: 'fully, satisfactorily, properly, very',
  werrk: 'in a short time, quickly, hurry up, first (in series)',
  weykan:
    'give, hand over, distribute, hand out, share, Distribute, hand out, share (also on social media)., sell something',
  widnan: 'hate, dislike',
  wirlam: 'stringybark raft, canoe made of stringybark',
  wodbun: 'swat, slap, ritually hit with leafy branch, fan',
  kunwok: 'language, word, message',
  woknan: 'say goodbye, farewell , call out to ancestors at a sacred site',
  wokwon: 'give someone a message, tell',
  wolbu: 'lacewing',
  woyung: 'worm',
  wubarr: 'Wubarr ceremony',
  wukme: 'swallow',
  wulud: 'sea turtle cooking juices',
  wurra: "what was it, oh that's right, oh",
  wurrik: 'clan name',
  yabok: 'sister, sis',
  yakbun: 'tip , pour',
  yakwon: 'finish, kill',
  nayaw: 'son',
  yawan: 'search for, look for',
  yawkan: 'be pregnant, carry child',
  yawoyh: 'again',
  yekke: 'cool weather season, early dry season',
  yeledj: 'slowly',
  yerre: 'behind, after, later, afterwards, as before',
  yibba: 'ornate burrowing frog',
  yibbun: 'rub, caress',
  kunyid: 'trouble, argument, fight, anger',
  yikan: 'You carry it',
  kunyil: 'artery, vein, sinew, tendon, nerve, vessel',
  yiman: 'like, similar to, such as',
  yingan: 'yourself',
  yirrme: 'peel lengthways, strip off',
  kunyon: 'calf, back of knee',
  yowayh: 'yes',
  yungki: 'first in sequence, ahead, in front',
  bakmi: 'He/she used to break it (verb: bakme)',
  balhmi: 'He/she used to close it (verb: balhme)',
  kabang: 'It is dangerous (base word: bang)',
  nabang: 'Dangerous (base word: bang)',
  kabanj: "It's smelly (base word: banj)",
  barlmi: 'It was filling up (verb: barlme)',
  kabame: 'It shines (verb: bame)',
  bameng: 'It shone (verb: bame)',
  yibaye: 'You bite it (verb: baye)',
  kabaye: 'He/she bites it (verb: baye)',
  bayeng: 'He/she bit it (verb: baye)',
  bebmi: 'He/she was appearing (verb: bebme)',
  belbmi: 'It was stuck to it (verb: belbme)',
  kabele: 'It is white/clean/clear (base word: bele)',
  bibom: 'He/she hit him/her (verb: bun)',
  bidbom: 'He/she climbed (verb: bidbun)',
  bimbom: 'He/she painted (verb: bimbun)',
  bonomi: 'He/she sniffed the liquid (verb: bonome)',
  kabore: 'It flows (verb: bore)',
  borrmi: 'He/she was snoring (verb: borrme)',
  buhmi: 'He/she was blowing (verb: buhme)',
  kabuk: 'It is dry (base word: buk)',
  kabume: 'It gives off smoke/mist (verb: bume)',
  ngabun: 'I hit it (verb: bun)',
  yibun: 'You hit it (verb: bun)',
  kanbun: 'You hit me (verb: bun)',
  dadjmi: 'He/she was cutting it (verb: dadjme)',
  dahmi: 'He/she used to refuse (verb: dahme)',
  dakmi: 'He/she was chopping (verb: dakme)',
  daweng: 'He/she put it in the sun (verb: dawe)',
  derdmi: 'He/she was chopping it with an axe (verb: derdme)',
  kanedi: 'We (three) are here (verb: di)',
  dilhmi: 'He/she was making dotted marks (verb: dilhme)',
  dimhmi: 'He/she was diving under the water (verb: dimhme)',
  dokmi: 'He/she used to leave (verb: dokme)',
  dolhmi: 'He/she was surfacing from under the water (verb: dolhme)',
  dombom: 'He/she extinguished it (verb: dombun)',
  dowkmi: 'It was exploding (verb: dowkme)',
  durnmi: 'He/she was kneading (verb: durnme)',
  djedmi: 'He/she was carving (verb: djedme)',
  djekmi: 'He/she was smiling (verb: djekme)',
  djobmi: 'He/she was chopping (verb: djobme)',
  djohmi: 'He/she was coughing (verb: djohme)',
  djuhmi: 'He/she was bathing (verb: djuhme)',
  djuymi: 'He/she was pressing (verb: djuyme)',
  ngakan: 'I take / I carry (verb: kan)',
  kakan: 'He/she takes (verb: kan)',
  kankan: 'You take me (verb: kan)',
  nakang: 'He is from (base word: kang)',
  nakare: 'old (base word: kare)',
  karrmi: 'He/she used to have (verb: karrme)',
  kayhmi: 'He/she was calling out (verb: kayhme)',
  kakele: 'He/she is scared (base word: kele)',
  kenami: 'He/she would take note of a location (verb: kename)',
  kewkmi: 'He/she was doubting (verb: kewkme)',
  yikeyo: 'You sleep (verb: keyo)',
  kakeyo: 'He/she sleeps (verb: keyo)',
  kakih: "It's wet (base word: kih)",
  kakirn: 'He/she is jealous (base word: kirn)',
  yikowe: 'You deceive him/her (verb: kowe)',
  kakowe: 'He/she deceives (verb: kowe)',
  kurrmi: 'He/she put (verb: kurrme)',
  kuykmi: 'He/she sprayed (verb: kuykme)',
  libmi: 'He/she sipped (verb: libme)',
  lurlmi: 'It swelled up (verb: lurlme)',
  madbom: 'He/she waited (verb: madbun)',
  mahmi: 'He/she used to agree (verb: mahme)',
  namak: 'Good (e.g. man, na- class thing) (base word: mak)',
  manmak: 'Good (food etc, vegetable class things)',
  yimang: 'You get (verb: mang)',
  kamang: 'He/she gets (verb: mang)',
  melmi: 'He/she was stepping on it (verb: melme)',
  modmi: 'He/she was relaxed (verb: modme)',
  mudbom: 'He/she plucked it (verb: mudbun)',
  yiname: 'You place it (verb: name)',
  kaname: 'He/she places it (verb: name)',
  nameng: 'He/she placed it (verb: name)',
  nganan: 'I see (verb: nan)',
  yinan: 'You see (verb: nan)',
  kanan: 'He/she sees (verb: nan)',
  ngani: 'I am here (verb: ni)',
  kaneni: 'We (three) are here (verb: ni)',
  yinome: 'You smell it (verb: nome)',
  kanome: 'He/she smells it (verb: nome)',
  nomeng: 'He/she smelled it (verb: nome)',
  mannud: 'Rotten (food etc, vegetable class things)',
  ngakmi: 'He/she was drowning (verb: ngakme)',
  ngalmi: 'It was beginning (verb: ngalme)',
  ngehmi: 'He/she was breathing (verb: ngehme)',
  yingun: 'You eat (verb: ngun)',
  kangun: 'He/she eats (verb: ngun)',
  njokmi: 'It was barking (verb: njokme)',
  rlobmi: 'He/she was running (verb: rlobme)',
  ngare: 'I go (verb: re)',
  kanere: 'We (three) go (verb: re)',
  royhmi: 'He/she was spying (verb: royhme)',
  wabmi: 'He/she was moving camp (verb: wabme)',
  wakbom: 'He/she turned around (verb: wakbun)',
  yiwake: 'You crawl (verb: wake)',
  kawake: 'He/she crawls (verb: wake)',
  wakeyi: 'He/she was crawling (verb: wake)',
  wakeng: 'He/she crawled (verb: wake)',
  wayhmi: 'He/she was raising it (verb: wayhme)',
  ngawe: 'I throw (verb: we)',
  kanewe: 'We (three) throw (verb: we)',
  nawern: 'Lots (base word: wern)',
  wehmi: 'He/she was vomiting (verb: wehme)',
  nawid: 'Not that one (base word: wid)',
  manwid: 'Not that one (food etc, vegetable class things) (base word: wid)',
  winhmi: 'He/she was winning (verb: winhme)',
  wirdmi: 'He/she was whistling (verb: wirdme)',
  kawob: 'It is light (base word: wob)',
  manwob: 'It is light (wood etc, vegetable class things) (base word: wob)',
  wokmi: 'It was poking out (verb: wokme)',
  ngawon: 'I give it to him/her (verb: won)',
  yiwon: 'You give it to him/her (verb: won)',
  kanwon: 'You give it to me (verb: won)',
  wungmi: 'He/she was smoking (verb: wungme)',
  wukmi: 'He/she was swallowing (verb: wukme)',
  wurrmi: 'It was rumbling (verb: wurrme)',
  wuymi: 'He/she was drowsy (verb: wuyme)',
  yakbom: 'He/she finished it (verb: yakbun)',
  yiyame: 'You spear it (verb: yame)',
  kayame: 'He/she spears it (verb: yame)',
  yameng: 'He/she speared it (verb: yame)',
  yaymi: 'He/she was itchy (verb: yayme)',
  yiyeme: 'You are shy (verb: yeme)',
  kayeme: 'He/she is shy (verb: yeme)',
  yibmi: 'It was sinking (verb: yibme)',
  yiyime: 'You say (verb: yime)',
  kayime: 'He/she says (verb: yime)',
  yimeng: 'He/she said (verb: yime)',
  yirrmi: 'He/she was peeling it lengthwise (verb: yirrme)',
  ngayo: 'I lie down (verb: yo)',
  kaneyo: 'We (three) lie down (verb: yo)',
  ngayoy: 'I lay down (verb: yo)',
  yiyoy: 'You lay down (verb: yo)',
  ngabom: 'I killed it (verb: bun)',
  yibom: 'You killed it (verb: bun)',
  ngawam: 'I went (verb: re)',
  yiwam: 'You went (verb: re)',
  ngamey: 'I took it (verb: mang)',
  yimey: 'You took it (verb: mang)',
  yinang: 'You saw it (verb: nan)',
  yikang: 'You took it (verb: kan)',
  yiweng: 'You threw it (verb: we)',
  yiwong: 'You gave it to him/her (verb: won)',
  biwong: 'He/she gave it to him/her (verb: won)',
  kanbom: 'You hit me (verb: bun)',
  benbom: 'He/she killed them (verb: bun)',
  kanmey: 'You took me (verb: mang)',
  bimey: 'He/she took him/her (verb: mang)',
  benmey: 'He/she took them (verb: mang)',
  binang: 'He/she saw him/her (verb: nan)',
  bikang: 'He/she took him/her (verb: kan)',
  yiyun: 'Lie down! (imperative, to one person) (verb: yo)',
  yiray: 'Go! (imperative, to one person) (verb: re)',
  yingu: 'Eat it! (imperative, to one person) (verb: ngun)',
  kanwo: 'Give it to me! (Imperative, to one person) (verb: won)',
  kanna: 'Look at me! (Imperative, to one person) (verb: nan)',
  yinani: 'You were looking at it (verb: nan)',
  yikani: 'You were taking it (verb: kan)',
  yibuni: 'You were hitting it (verb: bun)',
  nguni: 'He/she was eating it (verb: ngun)',
  mangi: 'He/she was getting it (verb: mang)',
  yimray: 'Come here! (Imperative, to one person) (verb: re)',
  yimre: 'You come here, you are coming here (verb: re)',
  yimka: 'Bring it here! (Imperative, to one person) (verb: kan)',
  kamkan: 'He/she is bringing it here (verb: kan)',
  kamre: 'He/she is coming here (verb: re)',
  ngamre: 'I am coming there (verb: re)',
  wakwak: 'Crow (bird) (main entry: wak)',
}
